<p-blockUI [blocked]="IsUIBlocked">
    <div style="text-align:center;">
        <p-progressSpinner></p-progressSpinner>
    </div>
</p-blockUI>